module.exports = __webpack_public_path__ + "img/icon_ckgl.562a87d7.png";